import React, {useState, useEffect} from 'react';

import {getMailMetrics, getDomainsMetrics} from '../../services/metrics';

import DataTable from '../../components/Table/DataTable';
import Loading from '../../components/Loading';

import { Chart, PieSeries, Tooltip } from '@devexpress/dx-react-chart-material-ui';
import { Palette, EventTracker } from '@devexpress/dx-react-chart';
import { schemeDark2 } from 'd3-scale-chromatic';

export default function EmailStats() {
    const [data, setData] = useState(null);
    const [domainMetrics, setDomainMetrics] = useState(null)

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        try {
            const {data} = await getMailMetrics();
            const {data: domain} = await getDomainsMetrics();
            setData(data);
            setDomainMetrics(domain);
        } catch (error) {
            console.log(error);
        }
    }

    const convertInArray = (obj) => {
        let array =  Object.keys(obj || {}).map(item => {return  {name: item, occurrencies: obj[item]}}, []);
        array = array.sort((a, b) => b.occurrencies - a.occurrencies).slice(0, 10);
        return array;
    }

    if(!data) return (<Loading />)
    return (
        <>
            <div className="channels-container">
                <h1>Email Data (Beta)</h1>
            </div>

            { domainMetrics &&

                <div>
                    <h2>Our Base</h2>

                        <Chart
                            data={domainMetrics}
                        >
                            <Palette scheme={schemeDark2} />
                            <PieSeries
                                valueField="val"
                                argumentField="domain"
                            />
                            <EventTracker />
                            <Tooltip />
                        </Chart>
                        <div className="email-table">
                                <h4>Domains:</h4>
                                <div>
                                    <DataTable 
                                        head={['domain', 'val']}
                                        body={domainMetrics}
                                        bodyColumn={['domain', 'val']}
                                    />
                                </div>
                        </div>

    
                </div>

            }

            {data && 
                <div>
                    <div className="email-rejection-types">
                        <h2>Bounces</h2>
                        <h3>Consolidate</h3>
                        <div className="email-data-wrapper">
                            <div className="email-table">
                                <h4>Domains:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.bounce.consolidate.domains)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                            <div className="email-table">
                                <h4>Channel:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.bounce.consolidate.channel)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>

                            <div className="email-table">
                                <h4>Issue</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.bounce.consolidate.issue)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                        </div>
                        <h3>ThisMonth</h3>
                        <div className="email-data-wrapper">
                            <div className="email-table">
                                <h4>Domains:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.bounce.lastMonth.domains)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                            <div className="email-table">
                                <h4>Channel:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.bounce.lastMonth.channel)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>

                            <div className="email-table">
                                <h4>Issue</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.bounce.lastMonth.issue)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="email-rejection-types">
                        <h2>Spam</h2>
                        <h3>Consolidate</h3>
                        <div className="email-data-wrapper">
                            <div className="email-table">
                                <h4>Domains:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.spam.consolidate.domains)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                            <div className="email-table">
                                <h4>Channel:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.spam.consolidate.channel)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>

                            <div className="email-table">
                                <h4>Issue</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.spam.consolidate.issue)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                        </div>
                        <h3>ThisMonth</h3>
                        <div className="email-data-wrapper">
                            <div className="email-table">
                                <h4>Domains:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.spam.lastMonth.domains)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                            <div className="email-table">
                                <h4>Channel:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.spam.lastMonth.channel)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>

                            <div className="email-table">
                                <h4>Issue</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.spam.lastMonth.issue)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="email-rejection-types">
                        <h2>Black List</h2>
                        <h3>Consolidate</h3>
                        <div className="email-data-wrapper">
                            <div className="email-table">
                                <h4>Domains:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.blackList.consolidate.domains)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                            <div className="email-table">
                                <h4>Reason:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.blackList.consolidate.reasons)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>

                        </div>
                        <h3>ThisMonth</h3>
                        <div className="email-data-wrapper">
                            <div className="email-table">
                                <h4>Domains:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.blackList.lastMonth.domains)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                            <div className="email-table">
                                <h4>Reason:</h4>
                                <div>
                                    <DataTable 
                                        head={['name', 'occurrencies']}
                                        body={convertInArray(data.blackList.lastMonth.reasons)}
                                        bodyColumn={['name', 'occurrencies']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }
        </>
    )
}
